import { render } from "./StockAnalysisChart.vue?vue&type=template&id=2d84fd4b"
import script from "./StockAnalysisChart.vue?vue&type=script&lang=js"
export * from "./StockAnalysisChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__